import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { checkWidgetAuthorization } from "./utils/checkAuthorization";
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { verifyUser } from "./logic/login/action";
import { restrictedRoutes } from "./restrictedRoutes";

const PrivateRoute = ({Component,store}) => {
    const selectorAuth = useSelector(state=>state.auth);
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    useEffect(() => {
      console.log('here user',Object.keys(selectorAuth));
      if(checkWidgetAuthorization(store)){
        console.log('here user is available',Object.keys(selectorAuth));
        if(Object.keys(selectorAuth.user).length !== 0){
          console.log('here user is available',Object.keys(selectorAuth).keys.length);
          console.log(location.pathname);
          console.log(restrictedRoutes);
          const isRestricted = restrictedRoutes.some(
            (route) => location.pathname === route || location.pathname.startsWith(`${route}/`)
          );
          if (isRestricted && selectorAuth.user?.role !== 'super_admin') {
            navigate('/admin/', { replace: true });
          }
        }else{
          console.log('here user is not available');
          verifyUser(dispatch);
        }
      }else{
        console.log('not loged in');
      }
    }, [])
    
    return (
          checkWidgetAuthorization(store)
            ? 
            <Component/> 
            : 
            <Navigate to='/admin/login'/>
        
    )
}

export default PrivateRoute;